import { render, staticRenderFns } from "./GameCollapse.vue?vue&type=template&id=214ddb0c&scoped=true"
import script from "./GameCollapse.vue?vue&type=script&lang=js"
export * from "./GameCollapse.vue?vue&type=script&lang=js"
import style0 from "./GameCollapse.vue?vue&type=style&index=0&id=214ddb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ddb0c",
  null
  
)

export default component.exports